import React, { useContext, useEffect, useState } from "react";
import { Box, Button, Checkbox, CircularProgress, Dialog, DialogContent, FormControl, FormControlLabel, FormGroup, IconButton, InputLabel, MenuItem, Select, TextField, Typography, Fab, DialogActions, Tabs, Tab, Autocomplete, CardContent, Card, Modal, DialogTitle } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { Check as CheckIcon, Clear as ClearIcon, Close, CropSharp, Details } from "@mui/icons-material";
import { CloseOutlined } from "@mui/icons-material";
import CloseIcon from '@mui/icons-material/Close';
import { Stack } from "@mui/material";
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import styled from "styled-components";
import AddRoutePlan from "../../components/modals/addRoutePlan";
import OpaqueLoading from "../opaqueLoading/opaqueLoading";
import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton, getGridStringOperators } from "@mui/x-data-grid";
import { AuthContext } from "../contextAPI/ContextAPI";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import searchIcon from "../../icons/searchIcon.svg"
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from "dayjs";
import PartyList from "./partyListModal";
const isMobile = window.innerWidth < 900;
const TotalAmountTypography = styled(Typography)`
  position: absolute;
  bottom: 10px;
  right: 10px;
  font-size: ${isMobile ? "14px" : "inherit"};
  bottom: ${isMobile ? "85px" : "70px"};
  right: ${isMobile ? "15px" : "70px"};
`;
const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px;
`;
const TableContainer = styled.div`
  // height: calc(
  //   100vh - ${isMobile ? "106px - 20px - 82.23px" : "100px - 20px - 23.77px"}
  // );
  width: ${isMobile ? "100%" : "98%"};
  // border: solid 1px lightGrey;
  border-radius: 8px;
  margin-left:${isMobile ? "0px" : "10px"};
  margin-bottom:${isMobile ? "0px" : "10px"};

`;
const TabsContainer = styled.div`
  ${isMobile && `
    height: calc(100vh - 176px - 20px - 43.77px);
  `}
`
// const StyledTabs = styled(Tabs)`
//   border-bottom: solid 1px lightGrey;
// `;

const MergePartyModal = ({ onClose, fetchData }) => {
    const [tabValue, setTabValue] = useState(0);
    const [loading, setLoading] = useState(false);
    const [dataGrid, setDataGrid] = useState([]);
    const [rowCount, setRowCount] = useState();
    const [endVisitRow, setEndVisitRow] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [endVisitModalOpen, setEndVisitModalOpen] = useState(false);
    const [newOrderStatus, setNewOrderStatus] = useState(0);
    const [visitModalData, setVisitModalData] = useState({});
    const [questionCategories, setQuestionCategories] = useState([]);
    const [openVisitViewModal, setOpenVisitViewModal] = useState(false);
    const [partyList, setPartyList] = useState([]);
    const [editModalData, setEditModalData] = useState({})
    const [openDialog, setOpenDialog] = useState(false);
    const [paginationModel, setPaginationModel] = useState({
        page: currentPage - 1,
        pageSize: 20,
    });
    const [modalData, setModalData] = useState()
    const [reason, setReason] = useState("");
    const [rejectData, setRejectData] = useState(null);
    const [editMode, setEditMode] = useState(false)
    const [modal, setModal] = useState(false)
    const [todayPunches, setTodayPunches] = useState([]);
    const [accessChanges, setAccessChanges] = useState([]);
    const [imageModalOpen, setImageModalOpen] = useState(false);
    const [primarySchoolSearch, setPrimarySchoolSearch] = useState("");
    const [secondarySchoolSearch, setSecondarySchoolSearch] = useState("");
    const [selectedPrimarySchool, setSelectedPrimarySchool] = useState(null);
    const [selectedSecondarySchool, setSelectedSecondarySchool] = useState(null);
    const [primarySchoolResults, setPrimarySchoolResults] = useState([]);
    const [primarySchoolLoading, setPrimarySchoolLoading] = useState(false);
    const [imageUrl, setImageUrl] = useState("");
    const [errors, setErrors] = useState({
        remark: false,
    });
    const [whoseClick, setWhoseClick] = useState("");
    const [selectionStep, setSelectionStep] = useState(0); // 1: select primary, 2: select secondary
    const [statusWork, setStatusWork] = useState([])
    const [workDone, setWorkDone] = useState([])
    const [feedback, setFeedback] = useState([])
    const [rm, setRm] = useState("")
    const [rsm, setRsm] = useState("")
    const [asm, setAsm] = useState("")
    const [rsms, setRsms] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [asms, setAsms] = useState([]);
    const [rms, setRms] = useState([]);
    const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)

    useEffect(() => {
        if (selectionStep == 1) {
            findPrimarySchool();
        }
        else if (selectionStep == 2) {
            findSecondarySchool();
        }
    }, [paginationModel.page, paginationModel.pageSize]);

    // const findPrimarySchool = async () => {
    //     setPrimarySchoolLoading(true);
    //     try {
    //         const results = await window.Platform.database.getAllSchool({ ownerId: "0GhgClJy21N" });
    //         if (results?.status === false && Array.isArray(results?.data)) {
    //             setPrimarySchoolResults(results.data);
    //         } else {
    //             setPrimarySchoolResults([]);
    //             window.NotificationUtils.showError("No schools found or error fetching schools.");
    //         }
    //     } catch (error) {
    //         setPrimarySchoolResults([]);
    //         window.NotificationUtils.showError("Error fetching schools.");
    //     } finally {
    //         setPrimarySchoolLoading(false);
    //     }
    // };
    const findPrimarySchool = async () => {
        setSelectionStep(1)
        try {
            setLoading(true);
            let payload = {
                filter: primarySchoolSearch,
                recordPerPage: paginationModel.pageSize,
                pageNumber: paginationModel.page,
            };
            let results = await window.Platform.database.getAllSchoolForMerge(payload);
            if (results?.status === false) {
                setRowCount(results.data1 || 0);
                const jsonArrayWithId = (results?.data || []).map((obj, index) => ({ ...obj, idIndex: index + 1 }));
                setAccessChanges(jsonArrayWithId);
            } else {
                window.NotificationUtils.showError("Error Fetching Data");
            }
        } catch (error) {
            console.error(error);
            window.NotificationUtils.showError("Something Went Wrong");
        } finally {
            setLoading(false);
        }
    };

    const findSecondarySchool = async () => {
        setSelectionStep(2);
        try {
            setLoading(true);
            let payload = {
                filter: secondarySchoolSearch,
                recordPerPage: paginationModel.pageSize,
                pageNumber: paginationModel.page,
            };
            let results = await window.Platform.database.getAllSchoolForMerge(payload);
            if (results?.status === false) {
                setRowCount(results.data1 || 0);
                const jsonArrayWithId = (results?.data || []).map((obj, index) => ({ ...obj, idIndex: index + 1 }));
                setAccessChanges(jsonArrayWithId);
            } else {
                window.NotificationUtils.showError("Error Fetching Data");
            }
        } catch (error) {
            console.error(error);
            window.NotificationUtils.showError("Something Went Wrong");
        } finally {
            setLoading(false);
        }
    };

    const handleMerge = async () => {
         const confirmMerge = window.confirm("Are you sure you want to merge these parties?");
        if (!confirmMerge) return;

        try {
            setLoading(true);
            let payload = {
                primaryPartyId:selectedPrimarySchool?.schoolId,
                secondaryPartyId:selectedSecondarySchool?.schoolId
            };
            let results = await window.Platform.database.mergeParty(payload);
            if (results?.status) {
                window.NotificationUtils.showSuccess(results?.message);
                onClose();
                fetchData();
            } else {
                window.NotificationUtils.showError(results?.message);
            }
        } catch (error) {
            console.error(error);
            window.NotificationUtils.showError("Something Went Wrong");
        } finally {
            setLoading(false);
        }
    };

    const renderContent1 = () => {
        return (
            <>
                <div className="row mt-2 mb-2 ml-2">
                    <Typography variant="body1" className="mt-2" sx={{ fontSize: "14px", fontWeight: "500", color: "black" }}>Select Page Size:&nbsp; </Typography>
                    <Select
                        value={paginationModel.pageSize}
                        variant="outlined"
                        size="small"
                        onChange={(e) => { setPaginationModel({ ...paginationModel, pageSize: e.target.value }) }}
                        sx={{ width: 90, fontSize: "14px", fontWeight: "500", color: "black" }}
                    >
                        {[10, 20, 30, 50, 100].map((role) => (
                            <MenuItem key={role} value={role} sx={{ fontSize: "14px", fontWeight: "500", color: "black" }}>{role}</MenuItem>
                        ))}
                    </Select>
                </div>

                {/* </Stack> */}
                <Stack direction={"column"} spacing={2} padding={0} width={"100%"}>

                    {(!accessChanges || accessChanges.length === 0) ? (
                        <Typography align="center" color="text.secondary" sx={{ py: 5 }}>
                            <b style={{ fontSize: "14px", color: "black", fontWeight: "500" }}>No data found</b>
                        </Typography>
                    )
                        : (
                            <DataGrid
                                className="payrollGrid"
                                style={{ height: !accessChanges.length ? '200px' : 'auto' }}
                                density="compact"
                                rows={accessChanges || []}
                                columns={getColumns()}
                                sx={{ color: "black", fontSize: "12px", fontWeight: "600" }}
                                rowHeight={60}
                                disableSelectionOnClick
                                disableRowSelectionOnClick
                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 10,
                                        },
                                    },
                                }}
                                rowCount={rowCount}
                                paginationModel={paginationModel}
                                paginationMode="server"
                                onPaginationModelChange={setPaginationModel}
                                getRowId={(row, index) => `${row.schoolId}-${row.ownerId}-${row.createdAt}` || index}
                            />
                        )}
                </Stack>
            </>
        )
    }

    const getColumns = () => {
        const stringOperators = getGridStringOperators().filter((op => ['contains'].includes(op.value)));
        return [
            {
                field: "scholId",
                headerName: "School ID",
                sortable: false,
                width: 150,
                editable: false,
                valueGetter: (params) => {
                    return params.row.schoolId || "N/A";
                },
                renderCell: (params) => {
                    let name = params.row.schoolId || "N/A";
                    return (
                        <Tooltip title={name}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "schoolName12",
                headerName: "School Name",
                sortable: false,
                width: 300,
                editable: false,
                valueGetter: (params) => {
                    return (params.row?.schoolName || "N/A");
                },
                renderCell: (params) => {
                    let name = params.row?.schoolName || "N/A"
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "email12",
                headerName: "Email",
                width: 300, filterable: false,
                sortable: false,
                valueGetter: (params) => {
                    return params.row?.email || "N/A";
                },
                renderCell: (params) => {
                    let name = params.row?.email || "N/A"
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "AddressLine1",
                headerName: "Address",
                width: 350,
                sortable: false,
                filterable: false,
                valueGetter: (params) => {
                    return params.row?.AddressLine1 || "N/A";
                },
                renderCell: (params) => {
                    let name = params.row.AddressLine1 || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
                        </Tooltip>
                    )
                },
            },
            // {
            //     field: "selectPrimary",
            //     headerName: "Select",
            //     width: 110,
            //     sortable: false,
            //     filterable: false,
            //     renderCell: (params) => (
            //         <Button
            //             variant="contained"
            //             color="success"
            //             size="small"
            //             onClick={() => {
            //                 setSelectedPrimarySchool(params.row);
            //                 setAccessChanges([]);
            //             }}
            //             disabled={!!selectedPrimarySchool}
            //         >
            //             {selectedPrimarySchool?.id === params.row.id ? "Selected" : "Select"}
            //         </Button>
            //     ),
            // },
            {
                field: "selectSchool",
                headerName: "Select",
                width: 190,
                sortable: false,
                filterable: false,
                renderCell: (params) => (
                    <Button
                        variant="contained"
                        color="success"
                        size="small"
                        onClick={() => {
                            if (selectionStep === 1) {
                                setSelectedPrimarySchool(params.row);
                                setAccessChanges([]);
                                setSelectionStep(2);
                            } else if (selectionStep === 2) {
                                setSelectedSecondarySchool(params.row);
                                setAccessChanges([]);
                                setSelectionStep(3);
                            }
                        }}
                    // disabled={
                    //     (selectionStep === 1 && !!selectedPrimarySchool) ||
                    //     (selectionStep === 2 && !!selectedSecondarySchool) ||
                    //     selectionStep > 2
                    // }
                    >
                        {selectionStep === 1 && selectedPrimarySchool?.id === params.row.id
                            ? "Primary Selected"
                            : selectionStep === 2 && selectedSecondarySchool?.id === params.row.id
                                ? "Secondary Selected"
                                : "Select"}
                    </Button>
                ),
            },
        ];
    };

    return (
        <>
            <Dialog disableEnforceFocus maxWidth="xl" fullWidth={true} open={true} >
                {loading && <OpaqueLoading />}
                <ModalHeaderContainer style={{ marginBottom: 0, paddingBottom: 1 }}>
                    <Typography variant={isMobile ? "h6" : "h5"} style={{ fontWeight: "500", color: "black" }}>
                        Merge Party
                        <Tooltip title="Order Id"></Tooltip>
                    </Typography>
                    <IconButton onClick={onClose}>
                        <CloseOutlined />
                    </IconButton>
                </ModalHeaderContainer>
                <TableContainer>
                    <TabsContainer>
                        {/* <StyledTabs
                            variant="fullWidth"
                            value={tabValue}
                            indicatorColor="primary"
                            textColor="primary"
                        >
                            <Tab label="Merge Party " sx={{ fontSize: "14px" }} />
                        </StyledTabs> */}
                        <div className="container my-3 d-flex justify-content-center" style={{ margin: '0 auto', flexDirection: 'column' }}>
                            <h3 className="text-center fw-bold mb-5 text-dark">
                                Merge Schools - Search & Manage
                            </h3>
                            <div className="row d-flex justify-content-center">
                                <div className=" col-md-6">
                                    <div className="card shadow-lg border-0 rounded-4">
                                        <div style={{ fontSize: "16px" }} className="card-header bg-success text-dark text-center rounded-top-4">
                                            <b> Primary School </b>
                                        </div>
                                        <div className="card-body">
                                            <b className="text-dark mb-3 fst-italic">
                                                Search by School ID or Name
                                            </b>
                                            <div className="input-group">
                                                <span className="input-group-text bg-success text-white">
                                                    <i className="bi bi-building"></i>
                                                </span>
                                                <input
                                                    type="text"
                                                    className="form-control mt-1"
                                                    placeholder="Enter School Name or ID"
                                                    aria-label="Primary School Search"
                                                    value={primarySchoolSearch}
                                                    onChange={(e) => { setPrimarySchoolSearch(e.target.value) }}
                                                />
                                                <button
                                                    className="btn btn-success rounded-pill ms-2 px-4 ml-1"
                                                    onClick={() => findPrimarySchool()}
                                                    aria-label="Search Primary School"
                                                >
                                                    <i className="bi bi-search me-2"></i> Find
                                                </button>
                                            </div>
                                           {selectedPrimarySchool && <div className=" d-flex justify-content-center">
                                              {selectedPrimarySchool && selectedPrimarySchool?.schoolId} - {selectedPrimarySchool && selectedPrimarySchool?.schoolName}
                                            </div>}
                                        </div>
                                    </div>
                                </div>
                                <div className=" col-md-6">
                                    <div className="card shadow-lg border-0 rounded-4">
                                        <div style={{ fontSize: "16px" }} className="card-header bg-primary text-white text-center fw-bold rounded-top-4">
                                            Secondary School
                                        </div>
                                        <div className="card-body">
                                            <b className="text-dark mb-3 fst-italic">
                                                Search by School ID or Name
                                            </b>
                                            <div className="input-group">
                                                <span className="input-group-text bg-primary text-white">
                                                    <i className="bi bi-building"></i>
                                                </span>
                                                <input
                                                    type="text"
                                                    className="form-control mt-1"
                                                    placeholder="Enter School Name or ID"
                                                    aria-label="Secondary School Search"
                                                    value={secondarySchoolSearch}
                                                    onChange={(e) => { setSecondarySchoolSearch(e.target.value) }}
                                                />
                                                <button
                                                    className="btn btn-primary rounded-pill ms-2 px-4 ml-1"
                                                    onClick={() => findSecondarySchool()}
                                                    aria-label="Search Secondary School"
                                                >
                                                    <i className="bi bi-search me-2"></i> Find
                                                </button>
                                            </div>
                                           {selectedSecondarySchool && <div  className=" d-flex justify-content-center">
                                                {selectedSecondarySchool && selectedSecondarySchool?.schoolId} - {selectedSecondarySchool && selectedSecondarySchool?.schoolName}
                                            </div>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Merge Button */}
                            <div className="row mt-2">
                                <div className="col text-center">
                                    <button
                                    disabled = {!selectedSecondarySchool?.schoolId || !selectedPrimarySchool?.schoolId}
                                        className="btn btn-warning btn-lg rounded-pill px-5 shadow"
                                        onClick={()=>handleMerge()}
                                        aria-label="Merge Schools"
                                    >
                                        <i className="bi bi-arrow-left-right me-2"></i> Merge School
                                    </button>
                                </div>
                            </div>
                        </div>

                        {renderContent1()}
                    </TabsContainer>
                </TableContainer>
            </Dialog>

        </>
    );
};
export default MergePartyModal;